/**
 * Numbers derived from a character definition that both the arena and the board need. They live
 * here rather than with the battle loop because the board's odds have to agree with the fight the
 * arena actually runs, and a module the arena owns cannot be imported by the rules it serves.
 */
import type { CharacterDef } from './types';

/**
 * Seconds a character needs before it can strike again. Stated per character where the roster says
 * so — a boulder is slower to heave than an arrow is to nock — and otherwise the pace of the
 * weapon's type.
 */
export function attackInterval(attack: CharacterDef['attack']): number {
  if (attack.interval !== undefined && attack.interval > 0) return attack.interval;
  return attack.type === 'melee' ? 0.6 : attack.type === 'aura' ? 0.5 : 1;
}

/** Nominal damage a second: what a weapon is worth once its recovery is counted. */
export function damagePerSecond(character: Pick<CharacterDef, 'attack'>): number {
  return character.attack.damage / attackInterval(character.attack);
}

/** Bigger, slower fighters for the higher tiers; fliers are quicker on their feet. */
export function characterSize(
  tier: number,
  flies: boolean,
): { halfWidth: number; height: number; speed: number } {
  const scale = 0.85 + tier * 0.12;
  return { halfWidth: 0.3 * scale, height: 1.7 * scale, speed: (flies ? 6.6 : 6) - tier * 0.25 };
}
